import { Form, NavLink, useLocation } from '@remix-run/react'
import { useRef, useState } from 'react'

import {
	Button,
	Icon,
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '#app/components/ui'
import { cn } from '#app/utils/misc.tsx'

interface MobileNavLinkProps {
	to: string
	children: React.ReactNode
	onClick?: () => void
}

function MobileNavLink({ to, children, onClick }: MobileNavLinkProps) {
	return (
		<NavLink
			to={to}
			onClick={onClick}
			className="'text-gray-700 block w-full rounded-md p-2 hover:bg-gray-50 hover:text-emerald-600 dark:text-white dark:hover:bg-slate-800"
		>
			{children}
		</NavLink>
	)
}

interface MobileNavIconProps {
	open: boolean
}

function MobileNavIcon({ open }: MobileNavIconProps) {
	return (
		<svg
			aria-hidden="true"
			className="h-3.5 w-3.5 overflow-visible stroke-slate-700"
			fill="none"
			strokeWidth={2}
			strokeLinecap="round"
		>
			<path
				d="M0 1H14M0 7H14M0 13H14"
				className={cn('origin-center transition', open && 'scale-90 opacity-0')}
			/>
			<path
				d="M2 2L12 12M12 2L2 12"
				className={cn(
					'origin-center transition',
					!open && 'scale-90 opacity-0',
				)}
			/>
		</svg>
	)
}

interface MobileNavigationProps {
	isLoggedIn: boolean | undefined
}

export default function MobileNavigation({
	isLoggedIn,
}: MobileNavigationProps) {
	const location = useLocation()
	const pathname = location.pathname
	const formRef = useRef<HTMLFormElement>(null)
	const [isOpen, setIsOpen] = useState(false)

	const toggleOpen = () => {
		setIsOpen(!isOpen)
	}

	return (
		<>
			<Popover open={isOpen} onOpenChange={setIsOpen}>
				<PopoverTrigger asChild>
					<Button variant="link" onClick={() => toggleOpen()}>
						<MobileNavIcon open={isOpen} />
					</Button>
				</PopoverTrigger>
				<PopoverContent className="mr-8">
					{isLoggedIn === true && (
						<div>
							<MobileNavLink to="/dashboard">Dashboard</MobileNavLink>
							{/* <LogoutButton /> */}
							<Form
								action="/logout"
								className="p-2"
								method="POST"
								ref={formRef}
							>
								<Icon className="text-body-md" name="exit">
									<button type="submit">Logout</button>
								</Icon>
							</Form>
							{/* <hr className="m-2 border-slate-300/40" /> */}
						</div>
					)}
					{isLoggedIn === false && (
						<>
							{pathname != '/login' && (
								<MobileNavLink to="/login">Log in</MobileNavLink>
							)}
							{pathname != '/signup' && (
								<MobileNavLink to="/signup">Sign up</MobileNavLink>
							)}
							{/* <hr className="m-2 border-slate-300/40" /> */}
						</>
					)}
					{pathname === '/' && (
						<>
							<hr className="m-2 border-slate-300/40" />

							<MobileNavLink to="#features">Features</MobileNavLink>
							<MobileNavLink to="#testimonials">Testimonials</MobileNavLink>
							{/* <MobileNavLink to="#pricing">Pricing</MobileNavLink> */}
						</>
					)}
				</PopoverContent>
			</Popover>
		</>
	)
}
